module.exports = __webpack_public_path__ + "static/media/features_recolecciones.806e2af9.jpg";